export default __webpack_public_path__ + "f043169d8f9cdad5c61e0f67ad9631cc.png";